import React, { forwardRef, useEffect, useRef, useState } from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import { useMobile } from 'utils/media';
import Icon from 'components/Icon';
import { PlaybackRates } from './PlaybackRates';
import './index.sass';

export const OtvetAudioPlayer = forwardRef(({src, ...props}, ref = null) => {
    const { isMobile } = useMobile();
    const [ audioRate, setAudioRate ] = useState(1);
    const player = useRef(null);

    useEffect(() => {
        if (player.current) {
            ref.current = {
                togglePlay: player.current.togglePlay
            }
        }
    }, [player.current])

    useEffect(() => {
        player.current.audio.current.playbackRate = audioRate;
    }, [audioRate]);

    useEffect(() => {
        setAudioRate(1);
    }, [src])

    return (
        <AudioPlayer
            src={ src }
            ref={ player }
            showSkipControls={ true }
            showJumpControls={ false }
            customVolumeControls={ isMobile ? [] : [ RHAP_UI.VOLUME ] }
            customAdditionalControls={ [<PlaybackRates audioRate={audioRate} setAudioRate={setAudioRate}/>] }
            showFilledVolume={true}
            customIcons={{
                play: <Icon name={'play-circle'} />,
                pause: <Icon name={'pause-circle'} />,
                previous: <Icon name={'skip-back'} />,
                next: <Icon name={'skip-forward'} />,
                volume: <Icon name={'speaker-high'} />,
                volumeMute: <Icon name={'speaker-high'} />
            }}
            {...props}
        />
    )
})
